import React, { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { generateOTP, validateOTP } from '../../services/APIs';
import { getPlantByCode } from '../../services/APIs';
import { LoadingAnimationContext } from '../../contexts/LoadingAnimationContext';
import { PrecheckContext } from '../../contexts/PrecheckContext';
import { CustomModalContext } from '../../contexts/CustomModalContext';
import { FormattedMessage } from 'react-intl';
import RedirectToPromoVideo from './RedirectToPromoVideo';

const LandingPage = () => {
    const Navigate = useNavigate();
    const [mobileNumber, setMobileNumber] = useState<string>('');
    const [inputOtp, setInputOtp] = useState<string>('');
    const [orgCodeExists, setOrgCodeExists] = useState<boolean>(false);
    const [isOtpSent, setIsOtpSent] = useState<boolean>(false);
    const [isPlantEnabledForDriverApp, setIsPlantEnabledForDriverApp] = useState<boolean>(true);

    const { setShowLoading } = useContext(LoadingAnimationContext);
    const { precheckInfo, setPrecheckInfo,setUsDotFieldEnabled } = useContext(PrecheckContext);
    const { showNetworkErrorModal, showInvalidUrlModal, showInvalidOtpModal } =
        useContext(CustomModalContext);

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();

        if (!isOtpSent) {
            const response = await generateOTP(mobileNumber as string);
            if (response.status === 200) {
                setIsOtpSent(true);
                return;
            }
        } else {
            const response = await validateOTP(mobileNumber as string, inputOtp);
            if (response.status === 200) {
                const { name, phoneNumber, _id } = response.data.driver;
                sessionStorage.setItem('phoneNumber', phoneNumber);
                setPrecheckInfo({
                    ...precheckInfo,
                    submittedName: name,
                    submittedPhoneNumber: phoneNumber,
                    driverId: _id
                });
                Navigate('/driverInfo');
                return;
            } else {
                showInvalidOtpModal();
            }
        }
    };

    const checkForSavedPhoneNumber = async () => {
        const phoneNumber = sessionStorage.getItem('phoneNumber');
        if (phoneNumber) {
            Navigate('/driverInfo');
        }
    };

    useEffect(() => {
        setShowLoading(true);
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const orgCode = urlParams.get('org') || sessionStorage.getItem('orgCode') || '';

        if (!orgCode) {
            setShowLoading(false);
            showInvalidUrlModal();
            return;
        }
        async function validatePlantCode() {
            const getPlantRes = await getPlantByCode(orgCode as string);

            console.log(
                getPlantRes.data.plant.toggles.find((toggle: any) => toggle.name === 'driverApp')
                    .enabled
            );
            console.log(
                getPlantRes.data.plant.toggles.find((toggle: any) => toggle.name === 'usDotField')
            );
            const usDotFieldToggle = getPlantRes.data.plant.toggles.find((toggle: any) => toggle.name === 'usDotField');
            setUsDotFieldEnabled(usDotFieldToggle.enabled);
            

            if (getPlantRes.code === 'ERR_NETWORK') {
                showNetworkErrorModal();
                return;
            }
            if (
                Object.keys(getPlantRes.data.plant).length === 0 ||
                getPlantRes.data.plant.toggles.find((toggle: any) => toggle.name === 'driverApp')
                    .enabled === false
            ) {
                setIsPlantEnabledForDriverApp(false);
                return;
            }
            sessionStorage.setItem('orgCode', orgCode as string);
            sessionStorage.setItem('orgId', getPlantRes.data.plant.id);
            setPrecheckInfo({
                ...precheckInfo,
                orgId: getPlantRes.data.plant.id,
                orgCode: orgCode,
                plantId: getPlantRes.data.plant._id
            });
            sessionStorage.setItem('laneNumber', '1');
            setOrgCodeExists(true);
        }

        validatePlantCode();
        checkForSavedPhoneNumber();
    }, []);
  
    

    return (isPlantEnabledForDriverApp ? (
    // <ToggleContext.Provider value={{ usDotFieldEnabled,setUsDotFieldEnabled }}>
        <div className="d-flex flex-column justify-content-center landing-page">
            <form
                className="d-flex flex-column mx-4 login-form"
                onSubmit={(event) => handleSubmit(event)}>
                <label htmlFor="mobileNumber" className="d-flex flex-column">
                    <span className="form-title">
                        {!isOtpSent ? (
                            <FormattedMessage
                                id="landingPageTitle"
                                defaultMessage="Mobile Number"
                            />
                        ) : (
                            <FormattedMessage
                                id="landingPageVerifyTitle"
                                defaultMessage="Verification Code"
                            />
                        )}
                    </span>
                    <span className="form-subtitle">
                        {!isOtpSent ? (
                            <FormattedMessage
                                id="landingPageSubTitle"
                                defaultMessage="Please enter your mobile number to begin precheck"
                            />
                        ) : (
                            <FormattedMessage
                                id="landingPageVerifySubTitle"
                                defaultMessage="Please enter the code that was sent to your phone"
                            />
                        )}
                    </span>
                </label>
                {!isOtpSent ? (
                    <input
                        type="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={10}
                        className="form-control text-center"
                        id="mobileNumber"
                        value={mobileNumber}
                        placeholder="1234567890"
                        onChange={(event) => setMobileNumber(event.target.value as string)}
                    />
                ) : (
                    <input
                        type="tel"
                        inputMode="numeric"
                        pattern="[0-9]*"
                        maxLength={6}
                        className="form-control text-center"
                        id="otp"
                        value={inputOtp}
                        placeholder="000000"
                        onChange={(event) => setInputOtp(event.target.value as string)}
                    />
                )}

                <div className="text-center d-flex justify-content-center my-4">
                    <div className="d-flex flex-column justify-content-around">
                        <button
                            type="submit"
                            name="Login"
                            className="btn btn-dark md-button mb-2"
                            disabled={mobileNumber.length !== 10 || !orgCodeExists}>
                            <span className="text-white">
                                {isOtpSent ? (
                                    <FormattedMessage
                                        id="landingPageLoginButton"
                                        defaultMessage="Login"
                                    />
                                ) : (
                                    <FormattedMessage
                                        id="landingPageSubmitButton"
                                        defaultMessage="Submit"
                                    />
                                )}
                            </span>
                        </button>
                        {isOtpSent && (
                            <button
                                name="Login"
                                className="btn md-button bg-white border border-dark"
                                value="Login"
                                onClick={(event) => {
                                    event.preventDefault();
                                    generateOTP(mobileNumber as string);
                                }}>
                                <span className="text-dark">
                                    <FormattedMessage
                                        id="landingPageResendCodeButton"
                                        defaultMessage="Resend Code"
                                    />
                                </span>
                            </button>
                        )}
                    </div>
                </div>
            </form>

            <p className="fs-6 width-100 text-center text-muted">
                <FormattedMessage
                    id="dataRatesMayApply"
                    defaultMessage="Message and data rates may apply"
                />
            </p>
        </div>
        // </ToggleContext.Provider>    
) : (
        <RedirectToPromoVideo />
    )
    
);
};

export default LandingPage;
